import type { CartMachineState } from '../state-machine/cartMachine';
import { useCartActor } from '../CartProvider';
import { useSelector } from '@xstate/react';

export function useCartStateSelector<T>(selector: (state: CartMachineState) => T) {
  const cartActorRef = useCartActor()!;
  return useSelector(cartActorRef, selector);
}
